import { render, staticRenderFns } from "./TermsAuto.vue?vue&type=template&id=1ac21f54&scoped=true&"
import script from "./TermsAuto.vue?vue&type=script&lang=js&"
export * from "./TermsAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac21f54",
  null
  
)

component.options.__file = "TermsAuto.vue"
export default component.exports